__turbopack_context__.v({
  "fullwidth": "JVFuKW_fullwidth",
  "grayscale": "JVFuKW_grayscale",
  "wrapper": "JVFuKW_wrapper",
});
